import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import type React from 'react';
import { type ContentField, ContentFieldLabel, ContentFieldValue } from './ContentField';

interface MediaCardContentTwoColumnProps {
  fields: ContentField[];
}

interface MediaCardContentSingleColumnProps extends React.HTMLAttributes<HTMLDivElement> {
  fields: ContentField[];
}

export const MediaCardContentTwoColumn: React.FC<MediaCardContentTwoColumnProps> = ({ fields }) => {
  const classes = styles();
  return (
    <div className={classes.root}>
      <div className={classes.column}>
        {fields.map((field) => {
          return (
            <div className={classes.item} key={field.id}>
              <ContentFieldLabel field={field} />
            </div>
          );
        })}
      </div>
      <div className={classes.column}>
        {fields.map((field) => {
          return (
            <div className={classes.item} key={field.id}>
              <ContentFieldValue field={field} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const MediaCardContentSingleColumn: React.FC<MediaCardContentSingleColumnProps> = ({ fields, ...props }) => {
  const classes = styles();
  return (
    <div className={classes.root} {...props}>
      <div className={classes.singleColumn}>
        {fields.map((field) => {
          return (
            <div className={classes.item} key={field.id}>
              <div className={classes.label}>
                <ContentFieldLabel field={field} />
              </div>
              <div className={classes.value}>
                <ContentFieldValue field={field} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const styles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '10px',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flexGrow: 1,
  },
  singleColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  item: {
    cursor: 'pointer',
    minHeight: '20px',
  },
  label: {
    color: theme.palette.primary.main,
  },
  value: {
    color: theme.palette.secondary.contrastText,
  },
}));
